import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import Select from "react-select";
import rootReducer from "../../../../store";
import { setRendererFormState } from "../../../../slices/common/reducer";

const CustomMultiSelect = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  let optMultiArray = fieldEle?.["data-customvalue"].split("#");
  let optionsMulti = [];
  optMultiArray.forEach((opt) =>
    optionsMulti.push({ key: opt, value: opt, label: opt })
  );

  let key = databaseKey ? databaseKey : displayLabelKey;
  const disabledOptions = fieldEle?.["disabled-options"] || [];

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <Select
          id={newElfromJSON}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          name={key}
          options={optionsMulti}
          placeholder={fieldEle?.["display-placeholder"]}
          isMulti
          isDisabled={fieldEle?.["display-disabled"] === 1}
          isRequired={
            showRequired ? fieldEle?.["display-required"] === 1 : false
          }
          isOptionDisabled={(option) => disabledOptions.includes(option.value)}
          value={optionsMulti?.filter((option) =>
            formState[key]?.includes(option.value)
          )}
          onChange={(e) => {
            const selectedValues = e.map((option) => option.value);
            rootReducer.dispatch(
              setRendererFormState({ key, value: selectedValues })
            );
          }}
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 1050 }) }}
        />
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default CustomMultiSelect;
